/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Saved Views Hooks
 *
 * Barrel export for all saved views-related hooks
 */

"use client";

// PERFORMANCE: Explicit exports instead of export * for better tree-shaking

// Main public API
export type {
  SavedViewFilters,
  SavedViewActionsOptions,
} from "./use-saved-view-actions";
export { useSavedViewActions } from "./use-saved-view-actions";

export { useSavedViewsUnified } from "./use-saved-views-unified";

// Internal implementation (server-backed)
/**
 * Unified saved views hook - server-backed storage with normalized interface
 *
 * ⚠️ DEPRECATED AS PUBLIC API - Use useSavedViewsUnified instead
 *
 * This hook is now an internal adapter used by useSavedViewsUnified for
 * server-backed view types (projects, clients, contacts, estimates).
 *
 * @deprecated Use useSavedViewsUnified instead. This hook remains as an internal implementation detail.
 */
// Re-export types for convenience
export type {
  SavedViewType,
  SavedViewsResponse,
  UseUnifiedSavedViewsOptions,
} from "./types";
